import React, { useContext } from "react";
import { Col, Container, Input, Label, Row } from "reactstrap";
import InquiryContext from "../../../context/InquiryContext/InquiryContext";
import IsShowTitleORNot from "../../../common/isShowTitleORNot";
import { Cases, DELETE_CONFIRM, inquiryTheme } from "../../../constant";
import { ThemeNo } from "../../../../constant";
import { stepStyle1, stepStyle2 } from "../staps/StepsStyleFunction";
import {
  InquiryThemeOneStyle,
  InquiryThemeTwoStyle,
} from "./InquiryStyleFunction";
import ProductImageUploadPopup from "../../../Modals/imageUploade/productImageUploadPopup";
import ByteCardBuilderContext from "../../../context/BytecardBilderContext/ByteCardBuilderContext";
import Dividers from "../../../common/divider";
import { OpenModalCommonFunc, TostMessage } from "../../../utils";
import { delete_Multi_Image_Permanent } from "../apis/SliderApi/SliderApi";
import LoaderContext from "../../../../context/LoaderContext/LoaderContext";
import { UploadCloud } from "react-feather";
import { IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";

const InquiryPopup = (props) => {
  const {
    allPopupState,
    setAllPopupState,
    crop,
    setCrop,
    completedCrop,
    setCompletedCrop,
    scale,
    rotate,
  } = useContext(ByteCardBuilderContext);
  const { setFormData, fromData, isEdit } = useContext(InquiryContext);
  const { setLoaderShow } = useContext(LoaderContext);
  const { simpleValidator, imageUpload } = props;

  /**
   * input value change
   * @param {event} e
   */
  const changeFormValue = (e) => {
    const { value, name, checked } = e.target;

    setFormData((prev) => {
      if (name === "isTitleShow") {
        return {
          ...prev,
          [name]: checked,
        };
      } else if (name === "theme" && value == ThemeNo.ThemeTwo) {
        return {
          ...prev,
          [name]: value,
          style: InquiryThemeTwoStyle,
        };
      } else if (name === "theme" && value == ThemeNo.ThemeOne) {
        return {
          ...prev,
          [name]: value,
          style: InquiryThemeOneStyle,
        };
      } else {
        return {
          ...prev,
          [name]: value,
        };
      }
    });
  };
  const deleteImagePermanent = async () => {
    try {
      let confirmation = window.confirm(DELETE_CONFIRM);
      if (confirmation) {
        setLoaderShow(true);
        let formData = {
          fileName: fromData.image
            .split(`${process.env.REACT_APP_BUCKET_PRO_FOLDER_MULTI}/`)
            .pop(),
        };
        const { data } = await delete_Multi_Image_Permanent(formData);
        if (data.status === 200) {
          TostMessage({ message: data, type: "success", position: "center" });
          setFormData({ ...fromData, image: "" });
          setLoaderShow(false);
        }
      }
    } catch (error) {
      TostMessage({ message: error, type: "error" });
      setLoaderShow(false);
    }
  };
  /**
   * reupload image
   */
  const reupload = () => {
    setFormData((prev) => {
      return {
        ...prev,
        image: "",
      };
    });
  };
  return (
    <>
      <Container className="mb-5">
        <Row>
          <Col sm="12" xl="12">
            <div className="mt-4 d-flex flex-column justify-content-center ">
              <h6>{isEdit ? "Edit" : "Add New"}</h6>
              <Row className="mt-4">
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">
                    Title *{" "}
                    <IsShowTitleORNot
                      checked={fromData?.isTitleShow}
                      onChange={changeFormValue}
                    />{" "}
                  </Label>
                  <Input
                    className="form-control"
                    name="title"
                    type="text"
                    placeholder="Title *"
                    value={fromData?.title}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                    required
                  />
                  <p style={{ color: "red" }}>
                    {simpleValidator.current.message(
                      "Title",
                      fromData?.title,
                      "required"
                    )}
                  </p>
                </Col>

                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">{"Sub Title"}</Label>
                  <Input
                    className="form-control"
                    name="subTitle"
                    type="text"
                    placeholder="Sub Title *"
                    value={fromData?.subTitle}
                    onChange={(e) => changeFormValue(e)}
                    style={{ borderRadius: "0", color: "black" }}
                  />
                </Col>
                <Col md="12 mb-3">
                  <Label htmlFor="validationCustom03">{"Theme *"}</Label>
                  <select
                    name="theme"
                    id="theme"
                    className="form-select"
                    style={{ borderRadius: "0", color: "black" }}
                    value={fromData?.theme}
                    onChange={(e) => changeFormValue(e)}
                  >
                    <option value={""}>--Select--</option>
                    {inquiryTheme.map((ele) => {
                      return (
                        <option value={ele.theme} key={ele.theme}>
                          {ele.themeName}
                        </option>
                      );
                    })}
                  </select>
                </Col>
                {+fromData?.theme === ThemeNo.ThemeTwo && (
                  <>
                    <Dividers divide="IMAGE" />
                    <Row>
                      <Col md="6 mb-3">
                        <div
                          className="aj-uploader d-flex flex-wrap  justify-content-center  align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          {!fromData?.image && (
                            <span
                              onClick={() => {
                                OpenModalCommonFunc(
                                  Cases.PRODUCT_UPLOAD,
                                  setAllPopupState
                                );
                              }}
                            >
                              <UploadCloud />
                            </span>
                          )}

                          {fromData?.image && (
                            <img
                              src={fromData?.image || ""}
                              alt=""
                              style={{
                                width: "80%",
                                height: "98%",
                                objectFit: "contain",
                                position: "absolute",
                              }}
                              onClick={() => {
                                deleteImagePermanent();
                              }}
                            />
                          )}
                          {fromData.images && (
                            <>
                              {" "}
                              <IconButton
                                edge="start"
                                color="inherit"
                                aria-label="close"
                                style={{
                                  color: "red",
                                  position: "absolute",
                                  top: "-22px",
                                  left: "1px",
                                }}
                                onClick={() => deleteImagePermanent()}
                              >
                                <Close
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: "bold",
                                  }}
                                />
                              </IconButton>
                            </>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </Row>
            </div>
          </Col>
        </Row>
        <ProductImageUploadPopup
          allPopupState={allPopupState}
          setAllPopupState={setAllPopupState}
          crop={crop}
          setCrop={setCrop}
          completedCrop={completedCrop}
          setCompletedCrop={setCompletedCrop}
          scale={scale}
          rotate={rotate}
          image={fromData.image}
          setImage={setFormData}
          imageUpload={imageUpload}
          isEdit={isEdit}
          reupload={reupload}
          // aspect={1.37 / 1}
        />
      </Container>
    </>
  );
};

export default InquiryPopup;
